// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0b32c2ad","732":"7c996ba6","977":"f661cedb"}[chunkId] + ".chunk.js";
};